var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgManPlaying = function SvgManPlaying(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#DDEAFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5970_3296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 57
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5970_3296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8186 61.2321C55.8723 52.3164 50.9042 45.0119 44.5129 43.4007C38.8197 41.9774 34.0396 45.549 33.046 46.3278V38.0566H24.2377V46.3278C23.1636 45.5759 17.9001 41.9774 11.6967 43.4007C4.68769 45.0119 -0.736907 52.3164 -0.683198 61.2321C9.38723 61.1783 46.6075 61.1783 55.8186 61.2321Z",
    fill: "#B99EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.395 51.457L11.5356 61.2321",
    stroke: "#2B292D",
    strokeWidth: 1.3004,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.063 52.1284L43.6269 61.2321",
    stroke: "#2B292D",
    strokeWidth: 1.3004,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8186 61.2321C55.8723 52.3164 50.9042 45.0119 44.5129 43.4007C38.8197 41.9774 34.0396 45.549 33.046 46.3278V38.0566H24.2377V46.3278C23.1636 45.5759 17.9001 41.9774 11.6967 43.4007C4.68769 45.0119 -0.736907 52.3164 -0.683198 61.2321C9.38723 61.1783 46.6075 61.1783 55.8186 61.2321Z",
    stroke: "#B99EF4",
    strokeWidth: 1.0231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M33.0461 41.8968V38.0298H24.2378V44.3137C24.936 44.2332 32.7238 41.9774 33.0461 41.8968Z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.3004,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4094 61.4999C56.4631 52.4231 51.4145 44.9844 44.8888 43.3462C39.0883 41.8961 34.2276 45.5483 33.2071 46.3271V43.024L28.8835 47.8578L24.2377 43.024V46.3271C23.1367 45.5483 17.7927 41.8961 11.455 43.3462C4.31172 44.9844 -1.19346 52.4231 -1.13975 61.4999C9.14551 61.4462 47.0372 61.4462 56.4094 61.4999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.0231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.207 51.5396L11.3477 61.5026",
    stroke: "#2B292D",
    strokeWidth: 1.3237,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4385 52.2378L44.0024 61.5026",
    stroke: "#2B292D",
    strokeWidth: 1.3237,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.936 61.4733L27.0844 52.853H30.1458L32.0256 61.4733H24.936Z",
    fill: "#D9353A",
    stroke: "#D9353A",
    strokeWidth: 0.8904,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3926 47.5903H32.0256L30.2264 52.8538H26.977L25.3926 47.5903Z",
    fill: "#FF3E44",
    stroke: "#FF3E44",
    strokeWidth: 0.9557,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0497 42.624L28.6149 47.4578L26.3592 51.3786L20.8271 44.8261L24.0765 41.8452L24.0497 42.624Z",
    fill: "white",
    stroke: "#464444",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1532 42.6235L28.6147 47.4573L30.8705 51.3781L36.4025 44.8256L33.1532 41.7104V42.6235Z",
    fill: "white",
    stroke: "#464444",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3965 61.4455C45.7214 61.4455 52.9989 61.4723 56.4363 61.4723C56.49 52.3955 51.4414 44.9568 44.9157 43.3187C42.0692 42.5936 39.4643 43.1307 37.3965 43.9364V61.4455Z",
    fill: "#6565F2",
    stroke: "#6565F2",
    strokeWidth: 1.0231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5651 43.8826C17.3361 43.1038 14.5433 42.6473 11.5087 43.3455C4.36543 44.9836 -1.13975 52.4223 -1.08604 61.4991C2.83472 61.4723 10.7568 61.4723 19.5919 61.4723V43.8826H19.5651Z",
    fill: "#6565F2",
    stroke: "#6565F2",
    strokeWidth: 1.0231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5615 35.8539C35.9623 35.8539 41.9619 29.6139 41.9619 21.9165C41.9619 14.219 35.9623 7.979 28.5615 7.979C21.1607 7.979 15.1611 14.219 15.1611 21.9165C15.1611 29.6139 21.1607 35.8539 28.5615 35.8539Z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.0601,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9286 24.9229C41.935 24.6275 40.834 25.0571 40.0015 25.997C39.6792 18.5046 34.55 12.5698 28.3466 12.6772C22.2507 12.7846 17.3632 18.6926 17.1483 26.0239C16.3427 25.3525 15.4028 25.084 14.5434 25.3794C12.9859 25.9165 12.2877 28.0648 13.0127 30.2132C13.7378 32.3615 15.5908 33.6774 17.1483 33.1403C17.5511 33.0061 17.9271 32.7375 18.1956 32.3884C20.0486 37.2759 24.1305 40.6327 28.8031 40.579C33.5832 40.4984 37.6383 36.8462 39.2495 31.717C39.5718 32.2273 40.0283 32.6032 40.5654 32.7644C42.1498 33.2477 43.9491 31.8782 44.6204 29.7029C45.2649 27.5277 44.513 25.4062 42.9286 24.9229Z",
    fill: "#CAB3FC",
    stroke: "#CAB3FC",
    strokeWidth: 1.1754,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M26.0104 32.1497C25.9567 34.0832 24.3454 35.5871 22.385 35.5334C20.4515 35.4797 18.9208 33.8684 18.9745 31.9349C19.0282 30.0013 20.6395 28.4975 22.5999 28.5512C24.5334 28.6049 26.0641 30.2162 26.0104 32.1497Z",
    fill: "#9B44D6",
    stroke: "#9B44D6",
    strokeWidth: 1.2855,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M38.2828 32.1497C38.2291 34.0832 36.6179 35.5871 34.6575 35.5334C32.724 35.4797 31.1933 33.8684 31.247 31.9349C31.3007 30.0013 32.912 28.4975 34.8723 28.5512C36.8059 28.6049 38.3365 30.2162 38.2828 32.1497Z",
    fill: "#9B44D6",
    stroke: "#9B44D6",
    strokeWidth: 1.2855,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5497 27.2065C34.5497 27.9316 34.1469 28.5224 33.6098 28.5492C33.0996 28.5492 32.6699 27.9584 32.6699 27.2333C32.6699 26.5083 33.0727 25.9175 33.6098 25.8906C34.1201 25.8906 34.5497 26.4814 34.5497 27.2065Z",
    fill: "#09182D",
    stroke: "#09182D",
    strokeWidth: 1.0005,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8285 27.207C24.8285 27.9321 24.3989 28.5228 23.8886 28.5228C23.3784 28.5228 22.9487 27.9321 22.9487 27.1801C22.9487 26.4551 23.3784 25.8643 23.8886 25.8643C24.4257 25.8911 24.8285 26.4819 24.8285 27.207Z",
    fill: "#09182D",
    stroke: "#09182D",
    strokeWidth: 1.0005,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2036 24.2002C21.2036 24.2002 22.7343 22.4278 25.7957 23.6899Z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1768 24.1995C21.3916 23.8236 21.7407 23.5282 22.1167 23.3402C22.4926 23.1254 22.9223 23.0179 23.3788 22.9911C23.8085 22.9642 24.2382 23.0179 24.6678 23.1522C24.8827 23.2059 25.0706 23.2865 25.2586 23.3671C25.4466 23.4745 25.6346 23.5819 25.7957 23.6893V23.7162C25.7957 23.7162 25.7957 23.7162 25.7689 23.7162L25.2049 23.5013C25.0169 23.4476 24.8021 23.3939 24.6141 23.3671C24.2113 23.2865 23.8085 23.2596 23.4057 23.2865C23.0029 23.3133 22.6 23.3939 22.2241 23.555C21.8481 23.7162 21.499 23.931 21.1768 24.1995C21.2036 24.2264 21.2036 24.2264 21.1768 24.1995C21.1768 24.1995 21.1768 24.2264 21.1768 24.1995Z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5156 23.7698C31.5156 23.7698 33.3954 22.3734 36.1077 24.3069Z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4888 23.7438C31.7842 23.4215 32.187 23.2335 32.5898 23.1261C33.0195 23.0187 33.4492 23.0187 33.8788 23.0724C34.3085 23.153 34.7113 23.2872 35.0873 23.5021C35.2753 23.6095 35.4364 23.7438 35.6244 23.8512C35.7855 23.9854 35.9466 24.1466 36.0809 24.2808V24.3077C36.0809 24.3077 36.0809 24.3077 36.054 24.3077L35.5438 23.9854C35.3558 23.9049 35.1947 23.7975 35.0067 23.7169C34.6308 23.5558 34.2548 23.4215 33.852 23.3678C33.4491 23.3141 33.0463 23.2872 32.6435 23.3678C32.2675 23.4215 31.8647 23.5558 31.4888 23.7438C31.5156 23.7706 31.5156 23.7706 31.4888 23.7438C31.4888 23.7438 31.4888 23.7706 31.4888 23.7438Z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7481 30.2951C25.1778 30.9933 25.7686 31.5573 26.4399 31.8795C27.1113 32.2018 27.8901 32.2824 28.6689 32.3092C29.0448 32.3092 29.4208 32.2555 29.7699 32.1481C30.1459 32.0675 30.495 31.9064 30.8172 31.7184C31.1395 31.5304 31.4617 31.2887 31.7303 31.0202C32.0257 30.7517 32.2405 30.4294 32.4016 30.0534C32.4016 30.0534 32.4285 30.0266 32.4285 30.0534C32.4285 30.0534 32.4285 30.0534 32.4285 30.0803C32.2405 30.8859 31.6497 31.5304 30.9784 31.987C30.307 32.4435 29.4745 32.712 28.6689 32.712C27.8632 32.6852 27.0307 32.5778 26.3057 32.1749C25.5806 31.799 25.0435 31.1008 24.7212 30.3488C24.6944 30.2951 24.6944 30.2951 24.7481 30.2951C24.7213 30.2683 24.7213 30.2683 24.7481 30.2951Z",
    fill: "#09182D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4541 27.208L28.1318 30.35L29.2866 30.0546",
    fill: "#9B44D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4541 27.208L28.1318 30.35L29.2866 30.0546",
    stroke: "#09182D",
    strokeWidth: 1.0914,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4541 27.208L28.1318 30.35L29.2866 30.0546",
    stroke: "#09182D",
    strokeWidth: 1.0914,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.624 27.5566L16.8261 30.8597",
    stroke: "#09182D",
    strokeWidth: 0.9923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7138 27.5566L40.5386 30.8597",
    stroke: "#09182D",
    strokeWidth: 0.9923,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9385 11.4161C28.1316 9.67059 23.4858 10.3151 22.5459 12.8663C22.3042 13.5108 22.331 14.2358 22.5996 14.9878C21.4448 14.4507 19.8873 14.5581 18.5177 15.3369C16.4767 16.5185 15.5905 18.8011 16.5304 20.4124C17.4704 22.0505 19.8873 22.3996 21.9282 21.218C23.4589 20.3318 24.3451 18.828 24.2914 17.4584C25.5536 18.7205 27.3797 19.8753 29.5549 20.6541C34.3618 22.3996 39.0076 21.7551 39.9475 19.2039C40.8875 16.6528 37.7455 13.1617 32.9385 11.4161Z",
    fill: "#2B292D",
    stroke: "#2B292D",
    strokeWidth: 1.1151,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1108 27.6357C27.2988 27.5015 27.8359 27.2329 28.561 27.2329C29.2861 27.2329 29.7963 27.5283 30.0111 27.6626",
    stroke: "white",
    strokeWidth: 1.741,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1647 27.6361C27.0573 29.5696 24.9895 31.0198 22.5995 30.8587C20.1826 30.6975 18.3296 29.0057 18.4639 27.0722C18.5713 25.1386 20.6391 23.6885 23.0292 23.8496C25.4461 24.0108 27.299 25.7026 27.1647 27.6361Z",
    stroke: "white",
    strokeWidth: 1.5392,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6852 27.5551C38.5778 29.4886 36.51 30.9387 34.12 30.7776C31.7031 30.6165 29.8501 28.9246 29.9844 26.9911C30.0918 25.0576 32.1596 23.6075 34.5497 23.7686C36.9397 23.9297 38.7927 25.6215 38.6852 27.5551Z",
    stroke: "white",
    strokeWidth: 1.5392,
    strokeMiterlimit: 10
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManPlaying);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/man-playing.5f32fbdb502d98e766f7fc1922c8a816.blank.svg";